import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Transactions from "./Transactions";

export function ManageTransactions() {
  const consent = useSelector((state: any) => state.person.cardConsent);
  const card = useSelector((state: any) => state.card);
  const { t } = useTranslation();

  return (
    <Box>
      <Transactions />
      {card?.hasHiddenTransactions && !consent?.readConsent ? (
        <Typography
          sx={{
            color: "red",
            flexGrow: 1,
            textAlign: "center",
            marginTop: "0.2rem",
          }}
          variant="h5"
          component="div"
        >
          {t("searchCard.cardInfo.hiddenTransactions")}
        </Typography>
      ) : card?.extendedCard &&
        !(
          card?.extendedCard?.transactions?.length > 0 ||
          card?.extendedCard?.expiredTransactions?.length > 0
        ) ? (
        <Typography
          sx={{ flexGrow: 1, textAlign: "center", marginTop: "0.2rem" }}
          variant="h5"
          component="div"
        >
          {t("noTransactions")}
        </Typography>
      ) : null}
    </Box>
  );
}
